import {Toast} from 'vant';
	
// /** 
//  * 用于把用utf16编码的字符转换成实体字符，以供后台存储 
//  * @param  {string} str 将要转换的字符串，其中含有utf16字符将被自动检出 
//  * @return {string}     转换后的字符串，utf16字符将被转换成&#xxxx;形式的实体字符 
//  */
export let utf16toEntities = function (str) {
  var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则  
  str = str.replace(patt, function (char) {
    var H, L, code;
    if (char.length === 2) {
      H = char.charCodeAt(0); // 取出高位  
      L = char.charCodeAt(1); // 取出低位  
      code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法  
      return "&#" + code + ";";
      } else {
      return char;
     }
    });
     return str;
}
export let chkImgType = function (file) {
  let regex = /(.jpg|.jpeg|.png|.bmpI|.gif)$/;
  if (!regex.test(file.type)) {
	  Toast.fail('非图片格式文件无法上传')
    return false;
  } else {
    return true;
  }
}
export let FirstPin = [
    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U",
    "V", "W", "X", "Y", "Z", "#"
  ]
  //发送信息的时候给的参数是随机id
export let randomWord = function (randomFlag, min, max){
  var str = "",
    range = min,
    arr = [ "0","1","2","3","4","5","6","7","8","9","a", "b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q",
      "r","s","t","u","v","w","x","y","z","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T",
      "U","V","W","X","Y","Z"];
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min;
  }
  for (var i = 0; i < range; i++) {
    var pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}

export let chkURL = function(str_url){
	var strRegex = "^((https|http|ftp|rtsp|mms)?://)"
	+ "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@ 
	+ "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184 
	+ "|" // 允许IP和DOMAIN（域名）
	+ "([0-9a-z_!~*'()-]+\.)*" // 域名- www. 
	+ "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名 
	+ "[a-z]{2,6})" // first level domain- .com or .museum 
	+ "(:[0-9]{1,4})?" // 端口- :80 
	+ "((/?)|" // a slash isn't required if there is no file name 
	+ "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$"; 
	var re=new RegExp(strRegex); 
	if (re.test(str_url)){
		return (true); 
	}else{ 
		return (false); 
	}
}

// Generate four random hex digits. 
export let S4 = function() { 
   return (((1+Math.random())*0x10000)|0).toString(16).substring(1); 
};

export let chkAndroidOrios = function() {
	var u = navigator.userAgent,
	app = navigator.appVersion;
	var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	return isAndroid == true ? true : false;
};
export let chkWeiXin = function() {
	var ua = window.navigator.userAgent.toLowerCase();
	return (ua.indexOf('micromessenger') > -1);
};

export let compWxAuthUrl = function(wxConfigs,states){
	// 重定向地址重定到当前页面，在路径获取 code
	const rmdstr = 'auth_'+Math.random();
	let hrefUrl = wxConfigs.authurl_web?wxConfigs.authurl_web:"https://jiefang.shushizi.com/public/index.php/Regist/wxOauth";
	hrefUrl += hrefUrl.indexOf("?")>-1?"&":"?";
	hrefUrl += "_t="+rmdstr;
	let wxUri = wxConfigs.authurl_wx?wxConfigs.authurl_wx:'https://open.weixin.qq.com/connect/oauth2/authorize';
	wxUri += wxUri.indexOf("?")>-1?"&":"?";
	wxUri += 'appid=' + wxConfigs.appid;
	wxUri += '&redirect_uri=' + encodeURIComponent(hrefUrl);
	wxUri += '&response_type=code';
	wxUri += '&scope=snsapi_userinfo';
	wxUri += '&state=';
	wxUri += encodeURIComponent(JSON.stringify(states));
	wxUri += '#wechat_redirect';
	return wxUri;
}

export let num2chinese = function(num){
	var arr1 = ['零','一','二','三','四','五','六','七','八','九'];
	var arr2 = ['','十','百','千','万','十','百','千','亿','十','百','千','万','十','百','千','亿'];
	if(!num || isNaN(num)) return arr1[0];
	var eng = num.toString().split('');
	var rst = '';
	for(var i=0,il=eng.length; i<il; i++){
		var desi = il-1-i;
		rst = arr2[i] + rst;
		var ind = eng[desi];
		rst = arr1[ind]+rst;
	}
	rst = rst.replace(/零(千|百|十)/g,'零').replace(/十零/g,'十');
	rst = rst.replace(/零+/g,'零');
	rst = rst.replace(/零亿/g,'亿').replace(/零万/g,'万');
	rst = rst.replace(/亿万/g,'亿');
	rst = rst.replace(/零+$/g,'');
	rst = rst.replace(/^一十/g,'十');
	return rst;
}

export let leftPadStr = function(val, len, padchar){
	val = val.toString();
	let val_arr = val.split('');
	if(val_arr.length < len){
		for(var i=val.length; i<len; i++){
			val = padchar+val;	
		}
	}
	return val;
}

export let rightPadStr = function(val, len, padchar){
	val = val.toString();
	let val_arr = val.split('');
	if(val_arr.length < len){
		for(var i=val.length; i<len; i++){
			val += padchar;	
		}
	}
	return val;
}

export let goodUnit = {
	1:'g',
	2:'kg',
	3:'包',
	4:'件',
	5:'个',
	6:'根',
	7:'罐',
	8:'箱',
	9:'ml',
	10:'L',
	11:'厘米',
	12:'米',
	13:'平方厘米',
	14:'平方米',
	15:'立方厘米',
	16:'立方米'
}

  



// WEBPACK FOOTER //
// ./src/utils/common.js